import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

let messaging: any;

try {
  const app = initializeApp(firebaseConfig);
  
  // Only initialize messaging in production environment
  if ('serviceWorker' in navigator && 
      'Notification' in window && 
      process.env.NODE_ENV === 'production') {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
        messaging = getMessaging(app);
      })
      .catch((err) => {
        console.warn('Service Worker registration failed:', err);
      });
  } else {
    console.warn('Push notifications are not supported in this environment');
  }
} catch (error) {
  console.error('Firebase initialization error:', error);
}

export const requestNotificationPermission = async () => {
  try {
    if (!messaging) {
      console.warn('Firebase messaging not initialized');
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission === 'denied') {
      console.warn('Notification permission denied');
      return null;
    }

    if (permission === 'default') {
      console.warn('Notification permission dismissed');
      return null;
    }

    try {
      const currentToken = await getToken(messaging, {
        vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
      });

      if (!currentToken) {
        console.warn('Failed to generate notification token');
        return null;
      }

      return currentToken;
    } catch (error) {
      console.warn('Error getting notification token:', error);
      return null;
    }
  } catch (error) {
    console.warn('Error requesting notification permission:', error);
    return null;
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    if (!messaging) {
      console.warn('Firebase messaging not initialized');
      return;
    }
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });